import { Fragment, useState, useContext, useMemo } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/24/outline';
import { UIContext } from "contexts/UIContext";
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import ButtonSecondary from 'shared/Button/ButtonSecondary';


const Modal = () => {

	const { modalStore } = useContext(UIContext);
	const [ open, setOpen ] = useState(false);
	const [ loading, setLoading ] = useState(false);
  
	let test = useMemo(() => {
		if (modalStore.title === 'init') return 0;
		if (modalStore.title === 'CLOSE') {
			setOpen(false);
			return 0;
		}
		// const _modalStore = {...modalStore};

		setOpen(true);
	}, [modalStore]);

	const confirmButton = async (fn: any) => {
		
		setLoading(true);
		let sw = await fn();
		
		if(sw===1) {

		} else {

		}
		setOpen(false);
	}

	if (modalStore.title === 'init') return <></>;


	function ModalButton ({label, color, fn}: any) {

		const buttonClass = "inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
		let addClass = "";
		switch (color) {
			case "red": addClass = "bg-indigo-600"; break;
			case "gray": addClass = "bg-gray-400"; break;
			case "viseCare": addClass = "bg-visecare-blue"; break;
		}

		return (
			<>
			<button
				type="button"
				className={`${buttonClass} ${addClass}`}
				onClick={() => confirmButton(fn)}
				>
				{label}
			</button>
			</>
		);
	}


	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog as="div" className="relative z-100" onClose={setOpen}>
			<Transition.Child
				as={Fragment}
				enter="ease-out duration-300"
				enterFrom="opacity-0"
				enterTo="opacity-100"
				leave="ease-in duration-200"
				leaveFrom="opacity-100"
				leaveTo="opacity-0"
			>
				<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
			</Transition.Child>

			<div className="fixed inset-0 z-1000 overflow-y-auto">
				<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
					enterTo="opacity-100 translate-y-0 sm:scale-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100 translate-y-0 sm:scale-100"
					leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
				>
					<Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
					<div>
						{(modalStore.title === null)? 
							<div className="text-left sm:mt-5">
								<Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
								{modalStore.contents}
								</Dialog.Title>
									
							</div>
							:
							<div className="mt-3 text-left sm:mt-5">
								<Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
									{modalStore.title}
								</Dialog.Title>
								<div className="mt-2">
									<div className="text-sm text-gray-500">
										{modalStore.contents}
									</div>
								</div>
							</div>
						}	
					</div>

					<div className="flex justify-between mt-5 sm:mt-6 gap-x-2">
						{
							
							modalStore.buttons.map((item, idx) => {
								console.log(item)

								// <ModalButton key={idx} label={item.label} color={item.color} fn={item.fn} />
								
								switch(item.color) {
									case "ButtonPrimary":
										return (
											<ButtonPrimary
												key={idx}
												sizeClass="px-6 py-3 !rounded-xl"
												onClick={item.fn}
												disabled={loading}
											>
												{item.label}
											</ButtonPrimary>
										);
										break;
									case "ButtonSecondary":
										return (
											<ButtonSecondary
												sizeClass="px-6 py-3 !rounded-xl"
												onClick={item.fn}
											>
												{item.label}
											</ButtonSecondary>
										);
										break;
								}

							})
						}
					</div>
					</Dialog.Panel>
				</Transition.Child>
				</div>
			</div>
			</Dialog>
		</Transition.Root>
	)
}

export default Modal;